import { Fragment, useEffect } from "react";
import Footer from "./static/footer";
import Contact from "./static/contact";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const TermsPage = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const currentUser = useSelector((state) => state.currentUser);
  useEffect(() => {
    if (currentUser?.IsAuthenticated) {
      navigate("/");
    }
  }, [currentUser, navigate]);

  return (
    <Fragment>
      <div className="home-page" style={{ width: "100%", height: "100%" }}>
        <div id="blog" className="blog-area ptb-100 bg-f9f9f9">
          <div className="container">
            <div
              className="saas-section-title"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-delay="100"
            >
              <h2>
                {t("terms.terms")}<span>{t("terms.conditions")}</span>
              </h2>
              <div className="bar"></div>
              <div class="terms-container">
                <h1>
                  {t("terms.termsandcond")}
                </h1>
                <p>
                  <strong>{t("terms.date")}</strong> {t("terms.date1")}
                </p>

                <p>
                 {t("terms.website")}{" "}
                  <a href="https://intelligence.cerebro360.ai">
                   {t("terms.website1")}
                  </a>{" "}
                  {t("terms.website2")}
                </p>

                <h2>{t("terms.article1")}</h2>
                <p>
                  {t("terms.article1-1")}
                </p>
                <p>
                  {t("terms.article1-2")}
                </p>

                <h2>{t("terms.article2")}</h2>
                <ul>
                  <li>
                    {t("terms.article2-1")}
                  </li>
                  <li>
                    {t("terms.article2-2")}
                  </li>
                  <li>
                    {t("terms.article2-3")}
                  </li>
                  <li>
                    {t("terms.article2-4")}
                  </li>
                </ul>

                <h2>{t("terms.article3")}</h2>
                <ul>
                  <li>
                    {t("terms.article3-1")}
                  </li>
                  <li>
                    {t("terms.article3-2")}
                  </li>
                  <li>
                    {t("terms.article3-3")}
                  </li>
                  <li>
                    {t("terms.article3-4")}
                  </li>
                  <li>
                    {t("terms.article3-5")}
                    <strong>{t("terms.bu")}<a href="mailto:BS@cerebro360.ai">BS@cerebro360.ai</a></strong>.
                  </li>
                  <li>
                    {t("terms.article3-6")}
                  </li>
                </ul>

                <h2>{t("terms.article4")}</h2>
                <ul>
                  <li>
                    {t("terms.article4-1")}
                  </li>
                  <li>
                    {t("terms.article4-2")}
                  </li>
                  <li>
                    {t("terms.article4-3")}
                  </li>
                  <li>
                    {t("terms.article4-4")}
                  </li>
                </ul>

                <h2>{t("terms.article5")}</h2>
                <ul>
                  <li>
                    {t("terms.article5-1")}
                  </li>
                  <li>
                    {t("terms.article5-2")}
                  </li>
                  <li>
                    {t("terms.article5-3")}
                  </li>
                </ul>

                <h2>{t("terms.article6")}</h2>
                <p>{t("terms.article6-1")}</p>
                <ul>
                  <li>{t("terms.article6-2")}</li>
                  <li>{t("terms.article6-3")}</li>
                  <li>{t("terms.article6-4")}</li>
                  <li>
                    {t("terms.article6-5")}
                  </li>
                  <li>
                   {t("terms.article6-6")}
                  </li>
                  <li>{t("terms.article6-7")}</li>
                  <li>
                    {t("terms.article6-8")}
                  </li>
                </ul>

                <h2>{t("terms.article7")}</h2>
                <ul>
                  <li>
                    {t("terms.article7-1")}
                  </li>
                  <li>
                    {t("terms.article7-2")}
                    <ul>
                      <li>{t("terms.article7-3")}</li>
                      <li>{t("terms.article7-4")}</li>
                      <li>{t("terms.article7-5")}</li>
                    </ul>
                  </li>
                  <li>
                   {t("terms.article7-6")}
                  </li>
                </ul>

                <h2>{t("terms.article8")}</h2>
                <p>{t("terms.article8-1")}</p>
                <ul>
                  <li>
                    <strong>{t("terms.article8-2")}</strong>{" "}
                    <a href="mailto:bs@cerebro360.ai">bs@cerebro360.ai</a>
                  </li>
                  <li>
                    <strong>{t("terms.article8-3")}</strong>{" "}
                    <a href="mailto:support@cerebro360.ai">
                      support@cerebro360.ai
                    </a>
                  </li>
                </ul>
                <p>
                  {t("terms.article8-4")}
                </p>

                <p>
                  <strong>
                    {t("terms.article8-5")}
                  </strong>
                </p>
                <p>{t("terms.date1")}</p>
                <p>
                  <strong>{t("terms.intech")}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <Contact />
        <Footer />
      </div>

      <style>
        {`  
        .home-page h1, .home-page h2 {
            color: #333;
        }
        .home-page .terms-container {
            margin: 0 auto;
            background: #fff;
            padding: 20px;
            border-radius: 8px;
            text-align:left;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        }
        .home-page .terms-container ul {
            padding-left: 20px;
        }
        .home-page  .terms-container .contact {
            margin-top: 20px;
            font-weight: bold;
        }
        .home-page .terms-container p{
        max-width:unset;
        }

         .home-page .terms-container h2{
          max-width:unset;
         }
        
        `}
      </style>
    </Fragment>
  );
};
